import { createTheme, Theme } from "@mui/material/styles";
import Grow from "@mui/material/Grow";
import { DefaultTheme } from "styled-components";
import { makeTokens, BaseColors } from "./tokens";

export interface AppThemes {
  styled: DefaultTheme;
  mui: Theme;
}

export function makeTheme(overrides?: Partial<BaseColors>): AppThemes {
  const tokens = makeTokens(overrides);
  const c = tokens.colors;

  const styled: DefaultTheme = { tokens };

  const mui = createTheme({
    palette: {
      primary: { main: c.teal },
      secondary: { main: c.green },
      text: { primary: c.ink, secondary: c.muted },
      background: { default: c.bg, paper: c.surface },
    },
    typography: {
      fontFamily: '"Nunito", sans-serif',
      button: { textTransform: "none", fontWeight: 800 },
    },
    shape: { borderRadius: tokens.radii.md },
    components: {
      MuiButton: {
        styleOverrides: {
          root: { borderRadius: 15, boxShadow: "none", fontWeight: 800 },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: { borderRadius: 13, backgroundColor: c.inputBg },
          notchedOutline: { borderColor: c.inputBorder },
        },
      },
      MuiDialog: {
        // Grow ≈ o scale+fade do CenterModal do protótipo, no lugar do Fade
        // seco padrão dos dialogs MUI remanescentes.
        defaultProps: { TransitionComponent: Grow, transitionDuration: 260 },
        styleOverrides: { paper: { borderRadius: tokens.radii.xl } },
      },
      MuiDrawer: {
        styleOverrides: {
          paperAnchorBottom: {
            borderTopLeftRadius: tokens.radii.sheet,
            borderTopRightRadius: tokens.radii.sheet,
          },
        },
      },
    },
  });

  return { styled, mui };
}
